import React from 'react';
import * as Fi from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

import { Skeletons, SkeletonText } from 'ui/components/skeleton';

import { currencyFormat } from 'utilities/common';
import { InvoiceAdditional } from 'services/action';
import { FormAdditional } from '../form';

const initialState = {
  invoice_additionals: null,
  additional: null,
  showDelete: false,
  showUpdate: false,
};

export const AdditionalList = ({ data, onSubmit, privilege }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Invoice.Show']
  );

  const [{ invoice_additionals, additional, showDelete, showUpdate }, setState] = React.useState(initialState);

  const $handleClose = async() => {
    setState((prevState) => ({ ...prevState, showDelete: false, showUpdate: false, additional: null }));
  }

  const $onLoad = async() => {
    const req = await Dispatch(InvoiceAdditional.$get(data?.id));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, invoice_additionals: req?.data }));
    }
  }

  const $handleDelete = async (val) => {
    setState((prevState) => ({ ...prevState, showDelete: true, additional: val }));
  };

  const $handleUpdate = async (val) => {
    setState((prevState) => ({ ...prevState, showUpdate: true, additional: val }));
  };

  const $emitDelete = async () => {
    const req = await Dispatch(InvoiceAdditional.$delete(additional?.id));

    if (req?.message === 'success') {
      $handleClose();
      onSubmit();
    }
  };

  React.useEffect(() => {
    if (!data) return
    $onLoad()
  }, [data])

  return (
    <div>
      {StateLoading ? (
        <div className="mb-3">
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
          <Skeletons height="150px" />
        </div>
      ) : (
        <div>
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Biaya Tambahan
          </div>

          {invoice_additionals?.length > 0 ? (
            <div className="log-container border-0 pt-2">
              {invoice_additionals
                ?.map((d, i) => (
                  <div
                    key={i}
                    className="border-bottom py-2 pe-2 row m-0 align-items-start"
                  >
                    <div className="col-8 p-0">
                      <div className="text-start title fs-8 fw-semibold text-capitalize ms-2">
                        {d?.note}
                      </div>
                      <div className="text-success fs-8  ms-2 fw-semibold">
                        {currencyFormat(d?.nominal, 'IDR')}
                      </div>
                    </div>
                    <div className="col-4 p-0 text-end">
                      {privilege && data?.document_status !== 'paid' && (
                        <div className="ms-n3">
                          <button
                            type="button"
                            className="btn btn-danger btn-xs me-2"
                            onClick={() => $handleDelete(d)}
                          >
                            Hapus
                          </button>
                          <button
                            type="button"
                            className="btn btn-xs"
                            onClick={() => $handleUpdate(d)}
                          >
                            Edit
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))
                .reverse()}
            </div>
          ) : (
            <div className="hr-text text-italic mt-4 mb-5"> belum ada </div>
          )}
        </div>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={$handleClose}
          />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={() => $emitDelete()}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* perbaharui additional */}
      <Modal
        show={showUpdate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Biaya Tambahan</Modal.Title>
        </Modal.Header>
        <FormAdditional
          data={data}
          additional={additional}
          onClose={() => {
            $handleClose();
            onSubmit();
          }}
        />
      </Modal>
    </div>
  );
};
